import React from "react";
// nodejs library to set properties for components

import PropTypes from "prop-types";
// @material-ui/core components
import { Box } from "@mui/material";

// core components
import styles from "../../assets/jss/material-dashboard-react/components/cardBodyStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function CardBody(props) {
  const { className, children, plain, profile, sx, ...rest } = props;

  const targetData = {
    "cardBody": true,
    "cardBodyPlain": plain,
    "cardBodyProfile": profile,
  };

  const keyArray = getKeyArray(targetData);

  let style = getBaseSxStyle(styles, keyArray);

  if (sx) {
    style = {
      ...style,
      ...sx
    };
  };


  return (
    <Box sx={style} {...rest}>
      {children}
    </Box>
  );
}

CardBody.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  children: PropTypes.node
};
